import {useMemo} from 'react';
import type {CodeListMap} from 'schemaDefinition/types';
import {useExpressionManifestationsBasedOnLocalCodelist} from './useExpressionManifestationsBasedOnLocalCodelist';
import {useExpressionManifestationsDigitalVersionLocalCodelist} from './useExpressionManifestationsDigitalVersionLocalCodelist';
import {useExpressionManifestationsLocalCodelist} from './useExpressionManifestationsLocalCodelist';

export const useExpressionLocalCodelistMap = (
  expressionId: string,
): CodeListMap => {
  const expressionManifestationCodelist =
    useExpressionManifestationsLocalCodelist(expressionId);
  const expressionManifestationBasedOnCodelist =
    useExpressionManifestationsBasedOnLocalCodelist(expressionId);
  const expressionManifestationDigitalVersionCodelist =
    useExpressionManifestationsDigitalVersionLocalCodelist(expressionId);
  return useMemo(
    (): CodeListMap => ({
      expression_manifestation: expressionManifestationCodelist,
      expression_manifestation_based_on: expressionManifestationBasedOnCodelist,
      expression_manifestation_digital_version:
        expressionManifestationDigitalVersionCodelist,
    }),
    [
      expressionManifestationBasedOnCodelist,
      expressionManifestationCodelist,
      expressionManifestationDigitalVersionCodelist,
    ],
  );
};
